export enum AssetUploadStatus {
    NONE = 'none',
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success',
}
